var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeuxiemePersonnageTeteTournee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fbbcaa;}.cls-3{fill:#173856;}.cls-4{fill:#20456e;}.cls-5{fill:#82cec4;}.cls-6{fill:#442114;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "int\xE9rieur voiture coll\xE8gue t\xEAte tourn\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 3000,
    height: 3000
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2776.25,1873.81s-13.47-312.08,6.73-381.68,39.3-259.33,55-344.64c0-134.72-95.87-302-206.56-346.89-130.22-52.76-195-48-272.43,19.4s-121.75,140.24-124,193-13.35,503.91,4.61,544.32,32.55,43.78,65.11,47.15,53.92,19,53.92,19L2371,1873.81Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1877,3000l-197-480.52S1695,2308,1773,2249s219,59,219,59Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3000,1823c-84.18-32.77-224.87-78.29-224.87-78.29s13.47,46-30.31,66.24-317.7,33.67-354.75,19.08-20.2-30.31-20.2-30.31-195.34,23.57-253.71,57.25-112.26,70.73-132.47,128S1836,3000,1836,3000H3000S2998,1866,3000,1823Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2838,1784c-18,40.42-174,101-287.38,89.81s-233.51-15.71-253.71-38.17-25.07-21.16-25.07-21.16,29.56-79.87,67.73-91.1,108.89,20.21,227.88,35.93c26.81,3.54,233.51,7.85,204.46-68.38C2792,1705.42,2856,1743.59,2838,1784Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2230,1160c0,30,1,66,42,107,0-64-4-80,32-76s60.24,128.56,64,168c4,42,69.55,95.19,97,154,21,45,35.89,37.51,40,81,84,30.22,281.22,5.42,273-11,0,0,103-469,94-514s-56-193-123-247-149.92-108-248-108c-135,0-132-3-251,88-92,70.36-83,183-56,183s11,21,11,21-3,80,8,105S2230,1130,2230,1160Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2130.1 3000 2203 2389 2166.55 3000 2130.1 3000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeuxiemePersonnageTeteTournee);
export default __webpack_public_path__ + "static/media/deuxieme_personnage_tete_tournee.3b08fb17dd846bd63ac09ae23d5f5c73.svg";
export { ForwardRef as ReactComponent };